var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _path, _g, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarChart1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    width: 30,
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    x2: 64,
    y1: 4.378,
    y2: 123.54
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c9ca"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 24.579,
    x2: 24.579,
    y1: 55.294,
    y2: 123.33
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051509,
    stopColor: "#4480f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3462bd"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 50.614,
    x2: 50.614,
    y1: 80.634,
    y2: 124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051509,
    stopColor: "#ec4431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3002,
    stopColor: "#e74330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6329,
    stopColor: "#da3f2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9828,
    stopColor: "#c33828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c23828"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 76.648,
    x2: 76.648,
    y1: 33.696,
    y2: 124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051509,
    stopColor: "#fdd835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2697,
    stopColor: "#f9d534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5326,
    stopColor: "#edcb32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7941,
    stopColor: "#d9ba2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4a829"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 102.68,
    x2: 102.68,
    y1: 99.1,
    y2: 124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0079082,
    stopColor: "#2ca94f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#207a39"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 4h120v120h-120z",
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#bdbdbd",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 4h120v120h-120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 104h120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 84h120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 64h120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 44h120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 24h120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104 4v120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84 4v120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 4v120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 4v120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 4v120"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.29 54.72h18.58v69.28h-18.58z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m41.32 80.63h18.58v43.37h-18.58z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m67.36 33.7h18.58v90.3h-18.58z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m93.39 99.1h18.58v24.9h-18.58z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m121 7v114h-114v-114zm3-3h-120v120h120z",
    fill: "#424242",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart1);
export default __webpack_public_path__ + "static/media/bar-chart1.d9fc5996327c9e6824de0bdac34f1975.svg";
export { ForwardRef as ReactComponent };